import React, { useState, Fragment } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Redirect } from "react-router-dom";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import "./changepassword.scss";
import "react-toastify/dist/ReactToastify.css";
import { getClass, getRandomInt } from "../../../utils/utils";
import Header from "../subheader/Header";

const editStoreSchema = Yup.object().shape({
  current_password: Yup.string().required("Required"),
  new_password: Yup.string()
    .required("Required")
    .min(6, "should be 6 chars minimum")
    .max(32, "should be 32 chars maximum"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("new_password"), null], "Passwords must match")
    .required("Passwords must match"),
});

const ChangePassword = (props) => {
  const initialVal = {
    current_password: "",
    new_password: "",
    confirm_password: "",
  };
  const [loading, setLoading] = useState(false);
  const [redirectBack, setRedirectBack] = useState(false);

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const showSuccess = () => {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const Update = (values) => {
    setLoading(true);
    setRedirectBack(false);
    apiJson.vendorProfile
      .changePassword({
        old_password: values.current_password,
        new_password: values.new_password,
        confirmation_password: values.confirm_password,
      })
      .then((response) => {
        if (response.success) {
          message = "Changed Successfully";
          showSuccess();
          setRedirectBack(true);
          setLoading(false);
        } else if (!response.status) {
          setLoading(false);
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        } else {
          setLoading(false);
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
              ? response.errors
              : "something went wrong";
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
  };

  return (
    <Fragment>
      <div className="vendor-page-right right-content store-page-desktop">
        <Header heading="Change Password" search={false} filters={null} />
        <div className="main-row store-page-content-container">
          <div className="form-container">
            <Formik
              initialValues={initialVal}
              validationSchema={editStoreSchema}
              enableReinitialize
              onSubmit={(values) => Update(values)}
            >
              {({ errors, touched, values }) => (
                <Form className="store-form mx-auto">
                  <fieldset>
                    <div className="row mx-0">
                      <div className="english-col col-6 mx-auto">
                        <div className="label">Current Password</div>
                        <Field
                          className={`w-100 ${getClass(
                            touched.current_password && errors.current_password
                          )}`}
                          name="current_password"
                          type="text"
                          placeholder="Current password"
                        />
                        {touched.current_password &&
                          errors.current_password && (
                            <div className="error">
                              {errors.current_password}
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="row mx-0">
                      <div className="english-col col-6 mx-auto">
                        <div className="label">New Password</div>
                        <Field
                          className={`w-100 ${getClass(
                            touched.new_password && errors.new_password
                          )}`}
                          name="new_password"
                          type="text"
                          placeholder="New password"
                        />
                        {touched.new_password && errors.new_password && (
                          <div className="error">{errors.new_password}</div>
                        )}
                      </div>
                    </div>
                    <div className="row mx-0">
                      <div className="english-col col-6 mx-auto">
                        <div className="label">Confirm Password</div>
                        <Field
                          className={`w-100 ${getClass(
                            touched.confirm_password && errors.confirm_password
                          )}`}
                          name="confirm_password"
                          type="text"
                          placeholder="confirm password"
                        />
                        {touched.confirm_password &&
                          errors.confirm_password && (
                            <div className="error">
                              {errors.confirm_password}
                            </div>
                          )}
                      </div>
                    </div>
                  </fieldset>
                  <div className="row button-row mx-0">
                    <div className="button-col col-6 mx-auto d-flex flex-column">
                      <div className="button-group d-flex align-items-center">
                        <button
                          className="blue-button"
                          type="submit"
                          disabled={loading}
                          key={getRandomInt(1, 1000)}
                        >
                          {loading ? (
                            <div className="d-flex justify-content-center align-items-center w-100">
                              <ClipLoader color="#fff" loading size={20} />
                            </div>
                          ) : (
                            "Save"
                          )}
                        </button>
                        <button
                          className="gray-button"
                          type="button"
                          onClick={() => setRedirectBack(true)}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  {redirectBack && <Redirect push to="/vendor/profile" />}
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ChangePassword;
